export function getTranslateValues (element) {
  const style = window.getComputedStyle(element)
  const matrix = style.transform || style.webkitTransform || style.mozTransform

  // No transform property. Simply return 0 values.
  if (matrix === 'none') {
    return {
      x: 0,
      y: 0,
      z: 0
    }
  } else if (!matrix && element.style.transform) {
    const cssMatrix = new window.WebKitCSSMatrix(element.style.transform)
    return {
      x: cssMatrix.m41,
      y: cssMatrix.m42,
      z: 0
    }
  }
  // Can either be 2d or 3d transform
  const matrixType = matrix.includes('3d') ? '3d' : '2d'
  const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')

  // 2d matrices have 6 values
  // Last 2 values are X and Y.
  // 2d matrices does not have Z value.
  if (matrixType === '2d') {
    return {
      x: matrixValues[4],
      y: matrixValues[5],
      z: 0
    }
  }

  // 3d matrices have 16 values
  // The 13th, 14th, and 15th values are X, Y, and Z
  if (matrixType === '3d') {
    return {
      x: matrixValues[12],
      y: matrixValues[13],
      z: matrixValues[14]
    }
  }
}

export const getGroupTransforms = (groupElement) => {
  let newValue = groupElement.elementDetails.elements.value;
  let elementLeastXPosition = 0, elementLeastYPosition = 0, elementRightBottomXPosition = 0, elementRightBottomYPosition = 0, blockTranslateX = 0, blockTranslateY = 0;
  const transformStyles = groupElement.elementDetails.styles.transform.split(' ');
  let elementTransform = {};
  transformStyles.forEach(data => {
    let key = data.split('(')[0];
    let value = data && data.match(/\((.*)\)/)[1];
    value = Number(value.replace(/[^\d.-]/g, ''));
    let pair = { [key]: value };
    elementTransform = { ...elementTransform, ...pair };
  });
  const currentTranslateX = elementTransform.translateX;
  const currentTranslateY = elementTransform.translateY;
  const elementPositions = newValue.map(storedEl => {
    const transformStyles = storedEl.elementDetails.styles.transform.split(' ');
    let elTransform = {};
    transformStyles.forEach(data => {
      let key = data.split('(')[0];
      let value = data && data.match(/\((.*)\)/)[1];
      value = Number(value.replace(/[^\d.-]/g, ''));
      let pair = { [key]: value };
      elTransform = { ...elTransform, ...pair };
    });
    return ({
      x: elTransform.translateX + currentTranslateX,
      y: elTransform.translateY + currentTranslateY,
      width: parseInt(`${storedEl.elementDetails.styles.width}`.replace('px', '')),
      height: parseInt(`${storedEl.elementDetails.styles.height}`.replace('px', '')),
    })
  });
  elementPositions.forEach((positions, index) => {
     const { x, y, width, height } = positions;
     if (index === 0) {
       elementLeastXPosition = x;
       elementLeastYPosition = y;
       elementRightBottomXPosition = x + width;
       elementRightBottomYPosition = y + height;
     } else {
       if (x < elementLeastXPosition) {
         elementLeastXPosition = x;
       }
       if (x + width > elementRightBottomXPosition) {
         elementRightBottomXPosition = x + width;
       }
       if (y < elementLeastYPosition) {
         elementLeastYPosition = y;
       }
       if (y + height > elementRightBottomYPosition) {
         elementRightBottomYPosition = y + height;
       }
   }
  });
  blockTranslateX = elementLeastXPosition;
  blockTranslateY = elementLeastYPosition;
  let width = elementRightBottomXPosition - elementLeastXPosition; // TODO : Check if this has to be divided by scaling
  let height = (elementRightBottomYPosition - elementLeastYPosition);
  newValue = newValue.map((newTransformEl, subIndex) => Object.assign({}, newTransformEl, {
    elementDetails: Object.assign({}, newTransformEl.elementDetails, {
      styles: Object.assign({}, newTransformEl.elementDetails.styles, {
        transform: `translateX(${elementPositions[subIndex].x - blockTranslateX}px) translateY(${elementPositions[subIndex].y - blockTranslateY}px) rotate(0) scaleX(1) scaleY(1)`,
        width: `${elementPositions[subIndex].width}px`,
        height: `${elementPositions[subIndex].height}px`,
      })
    })
  }));
  groupElement.elementDetails.elements.value = newValue;
  groupElement.elementDetails.styles = {
     ...groupElement.elementDetails.styles,
     transform: `translateX(${blockTranslateX}px) translateY(${blockTranslateY}px) rotate(0) scaleX(1) scaleY(1)`,
     width: `${width}px`,
     height: `${height}px`
  };
  return {groupElement, blockTranslateX, blockTranslateY, width, height};
}